import { useLocalStorage } from "usehooks-ts";

const LAST_WORKSPACE_ID_KEY = "lastWorkspaceId";

export const useLastWorkspaceId = (fallbackWorkspaceId?: string) => {
  return useLocalStorage(LAST_WORKSPACE_ID_KEY, fallbackWorkspaceId);
};
